import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumbs({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
      <Link to="/" className="flex items-center gap-1 transition-colors hover:text-primary-700">
        <i className="ri-home-4-line text-sm" />
        首页
      </Link>
      {items.map((item) => (
        <span key={item.label} className="flex items-center gap-2">
          <i className="ri-arrow-right-s-line text-sm text-foreground-300" />
          {item.to ? (
            <Link to={item.to} className="transition-colors hover:text-primary-700">
              {item.label}
            </Link>
          ) : (
            <span className="max-w-[220px] truncate text-foreground-700">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}